export default "__VITE_ASSET__c200c61c__"